import { Banco } from './banco';

export class Conta {

    private titularNome: string;
    private titularDocumento: string;
    private banco: Banco;
    private agencia: number;
    private agenciaDigito: string;
    private numero: number;
    private numeroDigito: string;
    private poupanca: boolean;

    public getTitularNome(): string {
        return this.titularNome;
    }

    public setTitularNome(titularNome: string): void {
        this.titularNome = titularNome;
    }

    public getTitularDocumento(): string {
        return this.titularDocumento;
    }

    public setTitularDocumento(titularDocumento: string): void {
        this.titularDocumento = titularDocumento;
    }

    public getBanco(): Banco {
        return this.banco;
    }

    public setBanco(banco: Banco): void {
        this.banco = banco;
    }

    public getAgencia(): number {
        return this.agencia;
    }

    public setAgencia(agencia: number): void {
        this.agencia = agencia;
    }

    public getAgenciaDigito(): string {
        return this.agenciaDigito;
    }

    public setAgenciaDigito(agenciaDigito: string): void {
        this.agenciaDigito = agenciaDigito;
    }

    public getNumero(): number {
        return this.numero;
    }

    public setNumero(numero: number): void {
        this.numero = numero;
    }

    public getNumeroDigito(): string {
        return this.numeroDigito;
    }

    public setNumeroDigito(numeroDigito: string): void {
        this.numeroDigito = numeroDigito;
    }

    public isPoupanca(): boolean {
        return this.poupanca;
    }

    public setPoupanca(poupanca: boolean): void {
        this.poupanca = poupanca;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/conta.ts